import { render, staticRenderFns } from "./purchaseTrend.vue?vue&type=template&id=0f15b983&scoped=true&"
import script from "./purchaseTrend.vue?vue&type=script&lang=js&"
export * from "./purchaseTrend.vue?vue&type=script&lang=js&"
import style0 from "./purchaseTrend.vue?vue&type=style&index=0&id=0f15b983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15b983",
  null
  
)

export default component.exports